import { Editor, EditorContent } from "@tiptap/react";

import useAccessibilityControlsContext from "@/view/utils/useAccessibilityControlsContext";
import { getEditorContentWrapperStyles } from "./GeniusEditorContent.styles";

interface GeniusEditorContentProps {
  editor: Editor;
}

const GeniusEditorContent = ({ editor }: GeniusEditorContentProps) => {
  const { currentFontSize } = useAccessibilityControlsContext();

  return (
    <div css={getEditorContentWrapperStyles(currentFontSize)}>
      <EditorContent editor={editor} />
    </div>
  );
};

export default GeniusEditorContent;
